import React, { memo } from "react";

import { SvgIcon } from "@origin-digital/ods-icons";

const IconWest = memo(() => {
  return (
    <>
      <SvgIcon
        data-id="icon-levels"
        size="small"
        viewBox="0 0 24 24"
        color="inherit"
      >
        <rect fill="none" height="24" width="24" />
        <path d="M9,19l1.41-1.41L5.83,13H22V11H5.83l4.59-4.59L9,5l-7,7L9,19z" />
      </SvgIcon>
    </>
  );
});

export { IconWest };
